import React from 'react';
import { observer } from 'mobx-react-lite';

import './style.sass';

import { UserInfo } from '../../UserInfo';
import { BackButton } from '../../BackButton';
import { useModelWithArguments } from 'app/hooks/useViewModel';
import { Routes } from 'src/types/routes';
import { UserViewModel } from 'app/viewModels/components/UserViewModel';

type Props = {
    userId: string,
};

export const UserInnerBreadCrumbs = observer(({ userId }: Props) => {
    const { name, email } = useModelWithArguments(UserViewModel, userId);

    return (
        <div className="user-inner-brea-crumbs">
            <BackButton to={Routes.Dashboard.Users}/>

            <UserInfo
                userName={name || '-'}
                email={email}
                userNameClassName='title-h2 dark-violet'
                emailClassName='caption-text grey-1'
            />
        </div>
    );
});
